/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InlineResponse2003ApplicationsStatus model module.
 * @module model/InlineResponse2003ApplicationsStatus
 * @version v1
 */
class InlineResponse2003ApplicationsStatus {
    /**
     * Constructs a new <code>InlineResponse2003ApplicationsStatus</code>.
     * @alias module:model/InlineResponse2003ApplicationsStatus
     */
    constructor() { 
        
        InlineResponse2003ApplicationsStatus.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineResponse2003ApplicationsStatus</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse2003ApplicationsStatus} obj Optional instance to populate.
     * @return {module:model/InlineResponse2003ApplicationsStatus} The populated <code>InlineResponse2003ApplicationsStatus</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse2003ApplicationsStatus();

            if (data.hasOwnProperty('total')) {
                obj['total'] = ApiClient.convertToType(data['total'], 'Number');
            }
            if (data.hasOwnProperty('applied')) {
                obj['applied'] = ApiClient.convertToType(data['applied'], 'Number');
            }
            if (data.hasOwnProperty('accepted')) {
                obj['accepted'] = ApiClient.convertToType(data['accepted'], 'Number');
            }
            if (data.hasOwnProperty('discarded')) {
                obj['discarded'] = ApiClient.convertToType(data['discarded'], 'Number');
            }
            if (data.hasOwnProperty('selected')) {
                obj['selected'] = ApiClient.convertToType(data['selected'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} total
 */
InlineResponse2003ApplicationsStatus.prototype['total'] = undefined;

/**
 * @member {Number} applied
 */
InlineResponse2003ApplicationsStatus.prototype['applied'] = undefined;

/**
 * @member {Number} accepted
 */
InlineResponse2003ApplicationsStatus.prototype['accepted'] = undefined;

/**
 * @member {Number} discarded
 */
InlineResponse2003ApplicationsStatus.prototype['discarded'] = undefined;

/**
 * @member {Number} selected
 */
InlineResponse2003ApplicationsStatus.prototype['selected'] = undefined;






export default InlineResponse2003ApplicationsStatus;

